export default class SocialBar {
  constructor() {
    console.info('SocialBar.constructor()');

    this.initListeners();
  }

    /*******************************************************************************
/* open new pop-up window for social media sharing
/******************************************************************************/
  socialWindow = function (url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left;
    window.open(url, 'NewWindow', params);
  };

  initListeners() {
    $('.js-button-toggle-share').on('click', (e) => {
      e.preventDefault();

      if (!$(e.currentTarget).is('.active')) {
        this.activateSocialDrawer(e);
      } else {
        this.deactivateSocialDrawer(e);
      }
    });

    $('body').on('click', '.social-drawer-dimmer', (e) => {
      e.preventDefault();
      this.deactivateSocialDrawer();
    });

    $(window).on('resize', () => {
      if ($('.social-drawer-dimmer')) {
        this.deactivateSocialDrawer();
      }
    });

    $(window).scroll(function (e) {
      const $el = $('.social-bar--desktop');

      if ($('body').hasClass('single-clx_recipe')) {
        if ($(this).scrollTop() < 90) {
          $el.removeClass('fixed');
        }
        if ($(this).scrollTop() > 90) {
          $el.addClass('fixed');
        }
      } else {
        if ($(this).scrollTop() < 490) {
          $el.removeClass('fixed');
        }
        if ($(this).scrollTop() > 490) {
          $el.addClass('fixed');
        }
      }
    });

    // set up print and share buttons
$('body').on('click', '[data-tag="share-facebook"]', (e) => {
  e.preventDefault();
  this.socialWindow(
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(document.URL)}&quote=${encodeURIComponent(
      document.URL
    )}`
  );
});

$('body').on('click', '[data-tag="share-x"]', (e) => {
  e.preventDefault();
  this.socialWindow(
    `https://x.com/intent/tweet?text=${encodeURIComponent(document.title)}:%20${encodeURIComponent(document.URL)}`
  );
});

$('body').on('click', '[data-tag="share-pinterest"]', (e) => {
  e.preventDefault();
  const pinterestImage = e.currentTarget.dataset.image;
  this.socialWindow(
    `http://pinterest.com/pin/create/button/?url=${encodeURIComponent(document.URL)}&media=${encodeURIComponent(
      pinterestImage || ''
    )}&description=${encodeURIComponent(document.title)}`
  );
});

$('body').on('click', '[data-tag="print"]', (e) => {
  e.preventDefault();
  window.print();
});
  }

  activateSocialDrawer(e) {
    console.info('SocialBar.activateSocialDrawer()');

    const $button = $(e.currentTarget);
    //const $parent = $button.parent();
    const $container = $button.closest('.social-bar--mobile');
    const $drawer = $container.find('.social-bar__sub-menu');
    //const offset = $(window).width() - ($parent.offset().left + $parent.outerWidth()) - 21; // 21px = 1.5em (match drawer padding)
    const dimmer = '<div class="social-drawer-dimmer"></div>';

    $button.addClass('active');
    $drawer.addClass('open');
    $(dimmer).appendTo('body').fadeIn('fast');
  }

  deactivateSocialDrawer() {
    const $button = $('.js-button-toggle-share');
    const $container = $('.social-bar--mobile');

    $button.removeClass('active');
    $container.find('.social-bar__sub-menu').removeClass('open');
    $('.social-drawer-dimmer').fadeOut('fast', function () {
      $('.social-drawer-dimmer').remove();
    });
  }
}
